import { defineStore } from "pinia";
import { ref } from "vue";

export const useGlobalStore = defineStore(
  "globalStoreDetails",
  () => {
    const sitecoreData: any = ref(null);
    const allowedTerminals: any = ref({});
    const userEmail: any = ref(null);

    const updateSitecoreData = (data: any) => {
      sitecoreData.value = data;
    };

    const updateAllowedTerminals = (data: any) => {
      allowedTerminals.value = data;
    };

    const updateUserEmail = (data: any) => {
      userEmail.value = data;
    };

    const loginRequiredTerminals: any = ref({
      terminalList: [],
      enabled: false
    });
    const tasTerminals: any = ref({
      terminalList: [],
      enabled: false
    });

    const updateLoginRequiredTerminals = (data: any) => {
      loginRequiredTerminals.value = data;
    };

    const updateTASTerminals = (data: any) => {
      tasTerminals.value = data;
    };
    return {
      sitecoreData,
      allowedTerminals,
      updateSitecoreData,
      updateAllowedTerminals,
      updateUserEmail,
      userEmail,
      updateLoginRequiredTerminals,
      loginRequiredTerminals,
      tasTerminals,
      updateTASTerminals
    };
  },
  {
    persist: false
  }
);
